import React, { useState } from 'react'
import { EditPageHeader } from '../../components/EditPageHeader'
import { useTranslation } from '../../locale/useTranslation'
import { ENTITYNAME, LOGEVENT, MODULE, TOAST_TYPES } from '../../framework/constant/constant'
import { utility } from '../../framework/utility/utilityProvider'
import * as API from "../../framework/API/api";
import BossDialog from '../../components/BossDialog'
import ToastNotification from '../../components/ToastNotification'

const LocationEditForm = (props) => {
    const lang = useTranslation();
  
    const blankDataItem = {
      ...props.item,
      SID: props?.item?.SID ?? 0,
      Name: props?.item?.copy ? 'copy of ' + props?.item?.Name : props?.item?.Name ?? '',
      IsDefault: props?.item?.IsDefault ?? false,
      Archive: props?.item?.Archive ?? false
    }
  
    const [dataItem, setDataItem] = useState(blankDataItem);
 
    function validationCheck() {
  
      if (dataItem.Name == undefined || dataItem.Name == "") {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_name_error_message });
        return false;
      }
      return true;
    }
  
    const handleSubmit = async (e) => {
  
      if (validationCheck()) {
        const saveData = {
          _id: dataItem._id,
          SID: dataItem.SID ?? 0,
          Name: dataItem.Name,
          IsDefault: dataItem.IsDefault ?? false,
          Archive: dataItem.Archive ?? false,
          checkDuplicate: true,
          query: [["Name", "=", dataItem.Name]],
        }
        console.log(saveData);
  
        let res = await API.saveData(ENTITYNAME.Location, saveData);
        if (res.success) {
          let logData = { event: res.message == "updated" ? LOGEVENT.UPDATE : LOGEVENT.INSERT, module: MODULE.LOCATION, data: res.data, message: res.message };
          API.SaveLogs(logData);
          utility.deleteLocalStorageItem(ENTITYNAME.Location);
          props.cancelEdit();
          props.refresh();
        }
        else {
          ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
      }
    }
  
    const onChange = (e) => {
  
      if (e.target.name == "Archive") {
        setDataItem({ ...dataItem, Archive: !dataItem.Archive });
      }else if (e.target.name == "isDefault") {
        setDataItem({ ...dataItem, isDefault: !dataItem.isDefault });
      } 
      else {
        setDataItem({ ...dataItem, [e.target.name]: e.target.value });
      }
  
    }
  
    return (
      <BossDialog
        title={props.item.SID > 0 ? props.item.Name : "Create Location"}
        onClose={props.cancelEdit}
        width={"500px"}
      >
        <EditPageHeader title={""} onSubmit={handleSubmit} onCancel={props.cancelEdit} showTitle={false} />
        <div className="row mt-2">
                <div className="col-12">
                    <label>{lang.name_label} *</label>
                    <input
                        name={"Name"}
                        type="text"
                        className="form-control form-control-sm"
                        onChange={onChange}
                        value={dataItem.Name}
                    />
                </div>
                <div className="col-3 mt-3" >
                    <input type={"checkbox"} name={"Archive"}
                        onChange={(e) => onChange(e)}
                        value={dataItem.Archive}
                        checked={dataItem.Archive} />
                    <label className="ml-1">{lang.archive}</label>
                </div>
                <div className="col-3 mt-3">
                    <input type="checkbox" name="IsDefault" onChange={onChange} value={dataItem.IsDefault} checked={dataItem.IsDefault}></input>
                    <label className="ml-1">{lang.default_label}</label>
                </div>
            </div>
            
      </BossDialog>)
}

export default LocationEditForm
